<template>
    <Error
        icon="lock-alt"
        title="You do not have permission"
        subtitle="This page and content is locked"
    >
        <!-- Description of the error -->
        <slot>
            <!-- `<p>If you think this is an error, please contact your administrator.</p>` -->
            <p>If you think this is an error, please contact your administrator.</p>
        </slot>

        <template #actions>
            <!-- Action buttons or links to be shown below the error message -->
            <slot name="actions" />
        </template>
    </Error>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faLockAlt} from '@fortawesome/pro-solid-svg-icons';

    import Error from '../Error.vue';

    library.add(faLockAlt);

    /**
     * @group Errors
     * This should be used in the admin area, when a user does not have the specific permissions to view a page.
     */
    export default {
        name: 'Forbidden',
        components: {
            Error,
        },
    };
</script>
